import { redirect } from "./Navigation.ts";

interface IRedirectEvent extends MessageEvent {
  data: string;
}

export function callbackListener(event: IRedirectEvent): void {
  if (window.location.origin === event.origin) {
    redirect(event.data);
  } else {
    console.warn("Event origin is not allowed!", event.origin);
  }
}
